/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable array-callback-return */
import { CouponTipsType } from '../../coupon/types';

import { i18n } from '../i18n';

import { GoodItem, CouponType, ExpireType } from '@tencent/wphk-act-base-types';
import dayjs from 'dayjs';

/** 是否为多券 */
export function isMultiCoupon(coupon: GoodItem): boolean {
  return coupon.perCount > 1;
}

/** 是否商户展示券 */
export function checkIsSpCoupon(couponType?: CouponType): boolean {
  // 三种商户展示券类型
  return !!couponType && [
    CouponType.SPCOUOPN,
    CouponType.SPCOUOPN_CDKEY,
    CouponType.SPCOUOPN_ONECDKEY,
  ].includes(couponType);
}

/** 是否是折扣券 */
export function checkIsDiscountCoupon(couponType?: CouponType): boolean {
  return couponType === CouponType.DISC;
}

/** 获取有效期限 */
export function getValidPeriod(coupon?: GoodItem): string {
  if (!coupon) return '';
  const { expireType, validTime, expireTime, expireDay } = coupon;
  if (expireType === ExpireType.FIXED) {
    return `${dayjs(validTime).format('YYYY.MM.DD')} - ${dayjs(expireTime).format('YYYY.MM.DD')}`;
  }
  return i18n('領取後x天内有效', { expireDay });
};

/** 商户展示券的展示信息 */
export function getSpCouponInfo() {
  return {
    tipsType: CouponTipsType.manual,
    tipsText: i18n('須手動啟用'),
  };
};

/**
 * 是否线上使用的商户展示券
 * 类型1-前往付款： customize_jump_name和customize_jump_url都为“前往付款”
 * 类型2-自定义跳转：两个字段不为空
 * 类型3-无跳转：两个字段都为空
 */
export function isOnlineMerchantCoupon(coupon?: GoodItem) {
  if (!coupon) return false;
  const { customizeJumpName, customizeJumpUrl } = coupon;
  return customizeJumpName !== customizeJumpUrl;
};
